var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("盘点单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.voucher.title))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.voucher.innerNo))]),
                          _vm._v(" "),
                          _vm.voucher.spotFlag
                            ? _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v("抽盘")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.quickFlag
                            ? _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v("快盘")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.openMode
                            ? _c("span", [_vm._v("明盘")])
                            : _c("span", [_vm._v("暗盘")])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("盘点部门全称\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.retailerComFullName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("sapn", [
                            _vm._v(_vm._s(_vm.voucher.principalName))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.confirmed
                            ? _c("span", [_vm._v("已确认")])
                            : _c("span", [_vm._v("未确认")])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建机构\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.creatorComName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.spotPrincipalName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          !_vm.voucher.spotFlag
                            ? _c("span")
                            : _vm.voucher.spotConfirmed
                            ? _c("span", [_vm._v("已确认")])
                            : _c("span", [_vm._v("未确认")])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.state == 0
                            ? _c("span", [_vm._v("未开始")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == 1
                            ? _c("span", [_vm._v("已开始")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == 2
                            ? _c("span", [_vm._v("已结束")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == -1
                            ? _c("span", [_vm._v("已取消")])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.startTime))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("结束时间\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.endTime))])]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("取消时间\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.cancelTime))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建时间\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.createTime))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建人\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.creatorName))])]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("需负责人签字\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.voucher.principalSigRequired ? "是" : "否"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(10),
                  _vm._v(" "),
                  _vm._m(11)
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(12),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.totalCount))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(14),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.checkedCount))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(15),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.voucher.totalCount -
                                  _vm.voucher.checkedCount
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(16),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.totalQuantity))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(17),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.checkedMoreQuantity))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(18),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.checkedLackQuantity))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(19),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.checkedFailQuantity || 0))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(20),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.assetIdleXQuantity))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(21),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.checkedLackNetWorth || 0))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(22),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.checkedMoreNetWorth || 0))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.voucher.principalSigDone
                ? _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(23),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: { src: _vm.voucher.principalSigImgUrl }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      ),
      _vm._v(" "),
      [
        _c(
          "div",
          {
            staticStyle: {
              "font-size": "15px",
              color: "#1a1a1a",
              "font-weight": "600",
              "text-align": "center",
              padding: "15px 0"
            }
          },
          [_vm._v("盘点明细")]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "simple-tbl",
            staticStyle: {
              width: "100%",
              "table-layout": "fixed",
              "border-collapse": "collapse",
              "border-spacing": "2px",
              "border-color": "gray",
              color: "rgb(102, 102, 102)",
              "font-size": "12px"
            }
          },
          [
            _c(
              "tbody",
              { staticClass: "body", staticStyle: { "margin-top": "10px" } },
              [
                _vm._m(24),
                _vm._v(" "),
                _vm._l(_vm.voucher.itemList, function(item) {
                  return _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.tmpNo) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.name || "") +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.shouldQuantity || 0) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.checkedQuantity || 0) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _c("span", [
                                item.checkedFlag == 0
                                  ? _c("span", { staticClass: "font-green" }, [
                                      _vm._v("正常")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.checkedFlag == 1
                                  ? _c("span", { staticClass: "font-red" }, [
                                      _vm._v("盘盈")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.checkedFlag == -1
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          { name: "else", rawName: "v-else" }
                                        ],
                                        staticClass: "font-red"
                                      },
                                      [_vm._v("盘亏")]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid rgb(26, 26, 26)",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { overflow: "hidden" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "normal",
                                "word-break": "break-all",
                                color: "#666666",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _c("span", [
                                item.physicalState == 0
                                  ? _c("span", { staticClass: "font-green" }, [
                                      _vm._v("正常")
                                    ])
                                  : item.physicalState == -1
                                  ? _c("span", [_vm._v("无实物")])
                                  : _c("span", { staticClass: "font-red" }, [
                                      _vm._v("损坏")
                                    ])
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("基本信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点单名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点方式")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("自盘负责人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("自盘负责人是否确认")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("抽盘负责人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("抽盘负责人是否确认")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("状态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("开始时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
      [
        _c("div", {
          staticClass: "label",
          staticStyle: {
            width: "76px",
            float: "left",
            color: "#1a1a1a",
            "font-weight": "600",
            "white-space": "normal",
            "word-break": "break-all"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "value",
            staticStyle: {
              "padding-left": "76px",
              "white-space": "normal",
              "word-break": "break-all"
            }
          },
          [_c("span")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
      [
        _c("div", {
          staticClass: "label",
          staticStyle: {
            width: "76px",
            float: "left",
            color: "#1a1a1a",
            "font-weight": "600",
            "white-space": "normal",
            "word-break": "break-all"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "value",
            staticStyle: {
              "padding-left": "76px",
              "white-space": "normal",
              "word-break": "break-all"
            }
          },
          [_c("span")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("盘点单统计信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("应盘条目数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("已盘条目数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("未盘条目数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("资产数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘盈数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘亏数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("损坏数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("闲置数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘亏净值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘盈净值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("签字结果")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("系统编号")])]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("名称")])]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("应盘数量")])]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("已盘数量")])]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("盘点结果")])]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid rgb(26, 26, 26)",
            "vertical-align": "middle",
            padding: "10px 4px"
          }
        },
        [
          _c("div", { staticStyle: { overflow: "hidden" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "76px",
                  float: "left",
                  color: "rgb(26, 26, 26)",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("label", [_vm._v("实物状态")])]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0430862", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0430862","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceStockCheckVoucherForPdf.vue
// module id = 3188
// module chunks = 0